import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Table, Badge, Button } from 'react-bootstrap';
import { FaUsers, FaDumbbell, FaCheckCircle, FaMoneyBillWave, FaExclamationTriangle } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const GymDashboard = () => {
  const navigate = useNavigate();
  const [stats, setStats] = useState({
    totalMembers: 0, activeMembers: 0, todayAttendance: 0, monthlyRevenue: 0
  });
  const [expiringMembers, setExpiringMembers] = useState([]);

  useEffect(() => {
    fetchStats();
    fetchExpiringMembers();
  }, []);

  const fetchStats = async () => {
    try {
      const [members, attendance, payments] = await Promise.all([
        axios.get('/api/gym/members'),
        axios.get('/api/gym/attendance', { params: { date: new Date().toISOString().split('T')[0] } }),
        axios.get('/api/gym/payments', { 
          params: { 
            dateFrom: new Date(new Date().setDate(1)).toISOString().split('T')[0],
            dateTo: new Date().toISOString().split('T')[0]
          }
        })
      ]);

      const active = members.data.filter(m => m.status === 'active').length;
      const todayPresent = attendance.data.filter(a => a.checkInTime).length;
      const revenue = payments.data.reduce((sum, p) => sum + parseFloat(p.amount || 0), 0);

      setStats({
        totalMembers: members.data.length,
        activeMembers: active,
        todayAttendance: todayPresent,
        monthlyRevenue: revenue
      });
    } catch (err) {
      console.error(err);
    }
  };

  const fetchExpiringMembers = async () => {
    try {
      const res = await axios.get('/api/gym/memberships/expiring');
      setExpiringMembers(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Container fluid className="py-4">
      <h2 className="mb-4">🏋️ Gym Dashboard</h2>

      <Row className="mb-4">
        <Col md={3}>
          <Card className="text-center shadow-sm" style={{ borderLeft: '4px solid #007bff' }}>
            <Card.Body>
              <FaUsers size={40} className="text-primary mb-2" />
              <h3>{stats.totalMembers}</h3>
              <p className="text-muted mb-0">Total Members</p>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3}>
          <Card className="text-center shadow-sm" style={{ borderLeft: '4px solid #28a745' }}>
            <Card.Body>
              <FaDumbbell size={40} className="text-success mb-2" />
              <h3>{stats.activeMembers}</h3>
              <p className="text-muted mb-0">Active Members</p>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3}>
          <Card className="text-center shadow-sm" style={{ borderLeft: '4px solid #ffc107' }}>
            <Card.Body>
              <FaCheckCircle size={40} className="text-warning mb-2" />
              <h3>{stats.todayAttendance}</h3>
              <p className="text-muted mb-0">Today's Attendance</p>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3}>
          <Card className="text-center shadow-sm" style={{ borderLeft: '4px solid #17a2b8' }}>
            <Card.Body>
              <FaMoneyBillWave size={40} className="text-info mb-2" />
              <h3>Rs. {stats.monthlyRevenue.toLocaleString()}</h3>
              <p className="text-muted mb-0">Monthly Revenue</p>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Card className="shadow-sm">
        <Card.Header className="bg-warning text-dark">
          <FaExclamationTriangle className="me-2" />
          <strong>Expiring Memberships (Next 7 Days)</strong>
        </Card.Header>
        <Card.Body>
          {expiringMembers.length === 0 ? (
            <p className="text-muted text-center">No memberships expiring soon</p>
          ) : (
            <Table hover responsive>
              <thead>
                <tr>
                  <th>Member</th>
                  <th>Phone</th>
                  <th>Package</th>
                  <th>End Date</th>
                  <th>Days Left</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {expiringMembers.map((m) => {
                  const daysLeft = Math.ceil((new Date(m.endDate) - new Date()) / (1000 * 60 * 60 * 24));
                  return (
                    <tr key={m.id}>
                      <td><strong>{m.member?.name}</strong></td>
                      <td>{m.member?.phone}</td>
                      <td>{m.package?.name}</td>
                      <td>{new Date(m.endDate).toLocaleDateString()}</td>
                      <td><Badge bg={daysLeft <= 3 ? 'danger' : 'warning'}>{daysLeft} days</Badge></td>
                      <td>
                        <Button size="sm" variant="success" onClick={() => navigate(`/gym/members`)}>
                          Renew
                        </Button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
};

export default GymDashboard;
